import LockIcon from '@mui/icons-material/Lock';
import { useTypedTranslate } from 'providers/i18n/hooks/useTypedTranslate';
import { Button } from 'shared/mui/Buttons';

export const NotificationKeyAccessDenied: React.FC = () => {
  const translate = useTypedTranslate();

  return <Button disabled label={translate('app.buttons.accessDenied')} startIcon={<LockIcon />} />;
};
